/**
 * Balmy Lightbox
 * Shared photo gallery lightbox used by multiple Balmy sections.
 *
 * Markup convention:
 *   - Gallery container:  data-blx-gallery="uid"  data-blx-srcs="url1|url2|url3"
 *   - Thumbnail:          data-blx-idx="0"  (inside a [data-blx-gallery])
 *   - External opener:    data-blx-open="uid"  data-blx-idx="0"
 */
(function () {
  'use strict';

  if (window.__balmyLightbox) return;
  window.__balmyLightbox = true;

  var overlay, imgEl, closeBtn, prevBtn, nextBtn, counterEl;
  var currentSrcs = [];
  var currentIdx = 0;

  /* ---- Build overlay (once) ---- */
  function buildOverlay() {
    if (overlay) return;

    overlay = document.createElement('div');
    overlay.id = 'blx-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Photo gallery');
    overlay.innerHTML =
      '<button id="blx-close" aria-label="Close">' +
        '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">' +
          '<line x1="1" y1="1" x2="17" y2="17"/><line x1="17" y1="1" x2="1" y2="17"/>' +
        '</svg>' +
      '</button>' +
      '<button id="blx-prev" aria-label="Previous">' +
        '<svg width="10" height="18" viewBox="0 0 10 18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">' +
          '<path d="M9 1L1 9L9 17"/>' +
        '</svg>' +
      '</button>' +
      '<div id="blx-img-wrap"><img id="blx-img" src="" alt=""></div>' +
      '<button id="blx-next" aria-label="Next">' +
        '<svg width="10" height="18" viewBox="0 0 10 18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">' +
          '<path d="M1 1L9 9L1 17"/>' +
        '</svg>' +
      '</button>' +
      '<div id="blx-counter"></div>';

    document.body.appendChild(overlay);

    imgEl     = document.getElementById('blx-img');
    closeBtn  = document.getElementById('blx-close');
    prevBtn   = document.getElementById('blx-prev');
    nextBtn   = document.getElementById('blx-next');
    counterEl = document.getElementById('blx-counter');

    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeLightbox(); });
    closeBtn.addEventListener('click', closeLightbox);
    prevBtn.addEventListener('click',  function () { navigate(-1); });
    nextBtn.addEventListener('click',  function () { navigate(1); });

    /* Keyboard */
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('blx-open')) return;
      var k = e.key;
      if (k === 'Escape' || k === 'Esc')   closeLightbox();
      if (k === 'ArrowLeft')                navigate(-1);
      if (k === 'ArrowRight')               navigate(1);
    });

    /* Touch swipe */
    var touchStartX = null;
    overlay.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) navigate(dx < 0 ? 1 : -1);
      touchStartX = null;
    }, { passive: true });
  }

  /* ---- Open / close / navigate ---- */
  function openLightbox(srcs, idx) {
    buildOverlay();
    currentSrcs = srcs;
    currentIdx  = Math.max(0, Math.min(idx, srcs.length - 1));
    showImage();
    overlay.classList.add('blx-open');
    document.body.classList.add('blx-body-lock');
  }

  function closeLightbox() {
    if (!overlay) return;
    overlay.classList.remove('blx-open');
    document.body.classList.remove('blx-body-lock');
    imgEl.src = '';
  }

  function navigate(dir) {
    currentIdx = (currentIdx + dir + currentSrcs.length) % currentSrcs.length;
    showImage();
  }

  function showImage() {
    imgEl.src = currentSrcs[currentIdx];
    var total = currentSrcs.length;
    counterEl.textContent = total > 1 ? (currentIdx + 1) + ' / ' + total : '';
    prevBtn.style.display = total > 1 ? '' : 'none';
    nextBtn.style.display = total > 1 ? '' : 'none';
  }

  /* ---- Parse pipe-separated URLs ---- */
  function getSrcs(galleryEl) {
    var raw = (galleryEl.getAttribute('data-blx-srcs') || '').trim();
    return raw ? raw.split('|').filter(Boolean) : [];
  }

  /* ---- Delegated click handler ---- */
  document.addEventListener('click', function (e) {
    /* Thumbnail / badge inside a gallery */
    var thumb = e.target.closest('[data-blx-idx]');
    if (thumb) {
      var gallery = thumb.closest('[data-blx-gallery]');
      if (!gallery) return;
      var srcs = getSrcs(gallery);
      if (!srcs.length) return;
      e.preventDefault();
      openLightbox(srcs, parseInt(thumb.getAttribute('data-blx-idx') || 0, 10));
      return;
    }

    /* "View All Photos" / any external opener */
    var opener = e.target.closest('[data-blx-open]');
    if (opener) {
      e.preventDefault();
      var uid     = opener.getAttribute('data-blx-open');
      var gallery = document.querySelector('[data-blx-gallery="' + uid + '"]');
      if (!gallery) return;
      var srcs = getSrcs(gallery);
      if (!srcs.length) return;
      openLightbox(srcs, parseInt(opener.getAttribute('data-blx-idx') || 0, 10));
    }
  });

})();
